// extracted by mini-css-extract-plugin
export default {"root":"PiVxGu","resetDesignAttributes":"MDrwHQ","bg":"YqUfCX","css-background":"yPXgy9","cssBackground":"yPXgy9"};